import { render, staticRenderFns } from "./modifyword.vue?vue&type=template&id=6eb88e47&scoped=true&"
import script from "./modifyword.vue?vue&type=script&lang=js&"
export * from "./modifyword.vue?vue&type=script&lang=js&"
import style0 from "./modifyword.vue?vue&type=style&index=0&id=6eb88e47&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb88e47",
  null
  
)

export default component.exports